
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["news",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96.75 87.47"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M0 37.21v39.7a10.58 10.58 0 0010.57 10.56h75.61a10.58 10.58 0 0010.57-10.56V0H17.36v37.21zm17.36 39.7a6.79 6.79 0 11-13.58 0V41h13.58zm2.36 5.28a10.56 10.56 0 001.42-5.28V3.78H93v73.13a6.8 6.8 0 01-6.79 6.79H18.84z"}}),_c('path',{attrs:{"d":"M28.93 12.31v21.33h56.25V12.31zM81.4 29.86H32.71V16.09H81.4zM58.06 43h27.12v3.78H58.06zM28.93 43h21.33v3.78H28.93zM58.06 54.57h27.12v3.78H58.06zM58.06 66.14h27.12v3.78H58.06zM28.93 54.57v15.35h21.33V54.57zm17.56 11.57H32.71v-7.79h13.78z"}})])])])
          )
        }
      }
    